import {default as RenderDataHtml} from "./render-data-html-fallback";
export default  RenderDataHtml;